import { useEffect, useState, useRef } from 'react';
import { firestore } from '../firebase/firebase';
import getDateString from '../utilities/getDateString';

export function useBookingEvents(storeId) {

  const [events, setEvents] = useState({});
  const isMounted = useRef(false);
  const storeRef = firestore.collection('stores').doc(storeId);
  // const eventsUnsubscribers = useRef([]);
  const slotsUnsubscribers = useRef([]);
  const lastEventsQuerySnapshot = useRef(null);

  useEffect(() => {
    isMounted.current = true;
    // console.log(storeId);
    const eventsUnsubscriber = getEvents();

    return (
      () => {
        isMounted.current = false;
        eventsUnsubscriber();
        // eventsUnsubscribers.current?.forEach((eventsUnsubscriber) => {
        //   eventsUnsubscriber();
        // });
        slotsUnsubscribers.current?.forEach((slotUnsubscriber) => {
          slotUnsubscriber.unsubscribe();
        });
      }
    );
  }, []);

  const getEvents = () => {
    const eventsRef = storeRef.collection('events').orderBy('timestamp');
    return eventsRef.onSnapshot((eventsQuerySnapshot) => {
      const addedEventSnapshots = [];      // Setup slots listeners.
      const modifiedEventSnapshots = [];  // Do nothing.
      const removedEventSnapshots = [];   // 1.Call unsubscribers. 2.Remove unsubscribers. 3.Remove from events state. 
      eventsQuerySnapshot.docChanges().forEach((docChange) => {
        if (docChange.type === 'added') {
          addedEventSnapshots.push(eventsQuerySnapshot.docs[docChange.newIndex]);
        } else if (docChange.type === 'modified') {
          modifiedEventSnapshots.push(eventsQuerySnapshot.docs[docChange.newIndex]);
        } else if (docChange.type === 'removed') {
          if (lastEventsQuerySnapshot.current?.docs[docChange.oldIndex]) {
            removedEventSnapshots.push(lastEventsQuerySnapshot.current.docs[docChange.oldIndex]);
          }
        }
      });
      lastEventsQuerySnapshot.current = eventsQuerySnapshot;

      // Handle added events.
      // 1.Call unsubscribers. 2.Remove unsubscribers. 3.Remove from events state. 
      const unsubscribers = slotsUnsubscribers?.current;
      removedEventSnapshots.forEach(removedEventSnapshot => {
        if (removedEventSnapshot.exists) {
          unsubscribers?.forEach((slotUnsubscriber, index) => {
            if (slotUnsubscriber.eventId === removedEventSnapshot.id) {
              slotUnsubscriber.unsubscribe();
              slotsUnsubscribers.current.slice(index, 1);
            }
          });
          setEvents(prevEvents => {
            const event = prevEvents[removedEventSnapshot.id];
            if (event) {
              delete prevEvents[removedEventSnapshot.id];
            }
            return ({
              ...prevEvents
            });
          });
        }
      });

      // Set up new events.
      addedEventSnapshots.forEach(newEventSnapshot => {
        getSlots(newEventSnapshot);
      });

    });
  };

  const getSlots = (eventSnapshot) => {
    if (!eventSnapshot) { return; }

    const eventData = eventSnapshot.data();

    slotsUnsubscribers.current.push({
      eventId: eventSnapshot.id,
      unsubscribe: eventSnapshot.ref.collection('slots').onSnapshot((slotsQuerySnapshot) => {
        const slots = [];
        // let nbrOfAllowed = 0;
        slotsQuerySnapshot.forEach((slotSnapshot) => {
          const slotData = slotSnapshot.data();
          // const allowed = bookingAllowed(slotData, user?.bookings, localAjustedTimestamp);
          slots.push({
            ref: slotSnapshot.ref,
            ...slotData,
            // allowed,
            dateString: getDateString(slotData.timestamp.toDate(), 'long'),
            eventId: eventSnapshot.id,
          });
          // allowed && nbrOfAllowed++;
        });
        const event = {
          ...eventData,
          slots,
          // nbrOfAllowed,
          dateString: getDateString(eventData.timestamp.toDate(), 'long'),
        }
        isMounted.current && setEvents(prevEvents => {
          if (typeof event.id !== 'undefined') {
            prevEvents[event.id] = event;
          }
          return {
            ...prevEvents
          };
        });
      })
    });
  };

  return events;

};